export default {
  'presentation.loading_pdf': 'Loading PDF...',

  // Remote
  'remote.pause': 'Pause',
  'remote.reset': 'Reset',
  'remote.reset_confirm': 'Reset the timer?',
  'remote.start': 'Start',
  'remote.pointer_mode': 'Pointer Mode',
  'remote.laser': 'Laser',
  'remote.highlight': 'Highlight',
  'remote.sketch': 'Sketch',
  'remote.magnifier': 'Magnifier',
  'remote.event_mode': 'Event Mode',
  'remote.event_off': 'Event{{number}} Off',
  'remote.event_on': 'Event{{number}}',
  'remote.touch_laser': 'Touch to show laser',
  'remote.highlight_size': 'Highlight size',
  'remote.touch_highlight': 'Touch to highlight',
  'remote.sketch_settings': 'Sketch Settings',
  'remote.clear_all': 'Clear All',
  'remote.pen_color': 'Pen Color',
  'remote.pen_width': 'Pen Width',
  'remote.touch_draw': 'Touch to draw',
  'remote.zoom_level': 'Zoom level',
  'remote.touch_zoom': 'Touch to zoom',
  'remote.controls': 'Controls',
  'remote.notes': 'Notes',
  'remote.no_notes': 'No notes available',
  'remote.notes_empty': 'Add notes from the dashboard',
};
